import type { ChartSeries } from '../types/report'

// recharts wants one row per x-value with a key per series. Merge the per-series
// {x,y} point lists into a single ordered row array keyed by series name.
export function mergeSeries(series: ChartSeries[]): Record<string, string | number>[] {
  const byX = new Map<string | number, Record<string, string | number>>()
  const order: (string | number)[] = []
  for (const s of series) {
    for (const p of s.points) {
      let row = byX.get(p.x)
      if (!row) {
        row = { x: p.x }
        byX.set(p.x, row)
        order.push(p.x)
      }
      row[s.name] = p.y
    }
  }
  return order.map((x) => byX.get(x)!)
}

// Theme-independent brand ramp colors for chart series (legible in light + dark).
export const SERIES_COLORS = [
  'var(--rb-turquoise-400)', // #47E3B2 — brand turquoise primary
  'var(--rb-magenta-500)',
  'var(--rb-amber-500)',
  'var(--rb-blue-500)',
]
